import {BASE_URL,GET, COUNTRIES_LIST} from "../constants";
import { statusParsing, jsonParsing } from "../utils";
import { getAccessToken } from "../../authActions/authActions";
  

export const fetchCountriesList = async (requestId) => {
  const token = await getAccessToken();
  const url = `${BASE_URL}${COUNTRIES_LIST}`;
  return fetch(url, {
      method: GET,
      headers: {
        "Content-Type": "application/json",
        "userauth" : `bearer ${token}`
      },
    })
    .then(statusParsing)
    .then(jsonParsing);
};